import React from "react";
import WeatherIcon from './WeatherIcon';
import './Forecast.css';

export default function ForecastPreview (props){
    return(
    <div className="col mb-2">
        <div className="forecastCard">
            <div className="card-body">
                <h5 className="card-title">{new Date (props.data.dt*1000).getHours()}:00</h5>
                 <WeatherIcon className="forecastIcon"  width="40" height="40" code={props.data.weather[0].icon} />
                 <p className="card-text">{Math.round(props.data.main.temp)} °C</p>
               
            </div>
        </div>
    </div>
    );
}